import { IconButton } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { ExampleSchemaWithRunsAndOptionalFields } from '../../types/schema';
import FullScreenIcon from './components/icons/FullScreenIcon.svg?react';

export function DatasetSessionCompareCellActions(props: {
  example: ExampleSchemaWithRunsAndOptionalFields;
  isVisible?: boolean;
  setDetailRunId?: (runId: string) => void;
  onOpenDetailSidebar: (exampleId: string) => void;
  bottomAlign?: boolean;
  className?: string;
  index?: number;
}) {
  const { example, onOpenDetailSidebar } = props;

  const handleExpandDetailedViewButtonClick = () =>
    onOpenDetailSidebar(example.id);

  return (
    <div
      className={cn(
        'absolute right-1 flex gap-1 rounded-md transition-opacity',
        '-top-5',
        props.className
      )}
      data-first-row-buttons={props.index}
    >
      <IconButton
        icon={FullScreenIcon}
        label="Expand detailed view"
        onClick={handleExpandDetailedViewButtonClick}
        color="secondary"
      />
    </div>
  );
}
